export function ReplaceAll(input: string, target: string, replace: string): string {
  const regex = new RegExp(`${target}`, "g")
  return input.replace(regex, replace)
}
